import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SincronizacionSapComponent } from './components/sincronizacionsap.component';

const routes: Routes = [
    {
        path: 'sincronizacionsap',
        component: SincronizacionSapComponent
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SincronizacionsapRoutingModule { }
